import { render, staticRenderFns } from "./FooterPay.vue?vue&type=template&id=85d97cbe&scoped=true&"
import script from "./FooterPay.vue?vue&type=script&lang=js&"
export * from "./FooterPay.vue?vue&type=script&lang=js&"
import style0 from "./FooterPay.vue?vue&type=style&index=0&id=85d97cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d97cbe",
  null
  
)

export default component.exports